import { render, staticRenderFns } from "./AGB.vue?vue&type=template&id=42f0acb2&scoped=true"
import script from "./AGB.vue?vue&type=script&lang=js"
export * from "./AGB.vue?vue&type=script&lang=js"
import style0 from "./AGB.vue?vue&type=style&index=0&id=42f0acb2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0acb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f0acb2')) {
      api.createRecord('42f0acb2', component.options)
    } else {
      api.reload('42f0acb2', component.options)
    }
    module.hot.accept("./AGB.vue?vue&type=template&id=42f0acb2&scoped=true", function () {
      api.rerender('42f0acb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AGB.vue"
export default component.exports